import { useIsAuth } from 'feature/auth/hooks'
import { useGetBankDetailsListQuery } from 'feature/company/redux/company.api'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { useAppSelector } from 'store/hooks'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'

import style from './ConfirmBankDetailsBlock.module.scss'

export function ConfirmBankDetailsBlock() {
  const isAuth = useIsAuth()
  const bankDetailsId = useAppSelector(
    state =>
      state.orderForm.forms[orderFormSpace.FormType.newCompany].bankDetailsId,
  )
  const { data: bankDetailsList } = useGetBankDetailsListQuery(undefined, {
    skip: !isAuth,
  })

  const selected = bankDetailsList?.items.find(
    item => item.id === bankDetailsId,
  )

  if (!selected) return null

  return (
    <InformationBlock title='Банковские реквизиты'>
      <div className={style.bankDetails}>
        <span className='default-text'>{selected.bankName}</span>
        <span className='default-text'>БИК: {selected.bik}</span>
        <span className='default-text'>
          К/С: {selected.correspondentAccount}
        </span>
        <span className='default-text'>Р/С: {selected.currentAccount}</span>
      </div>
    </InformationBlock>
  )
}
